import type { UploadSession } from "@/hooks/useUploads"

/**
 * Client-side user/email search over the loaded crop-session roll-ups (#1028).
 *
 * Server-side grouping (#1028) owns session identity + counts; the admin still
 * filters the LOADED sessions by coach name/email so an admin can find a
 * specific upload without paging the whole history. Empty query returns the
 * input unchanged; otherwise matches name OR email, case-insensitive.
 */
export function filterUploadSessions(
  sessions: UploadSession[],
  search: string
): UploadSession[] {
  const q = search.trim().toLowerCase()
  if (!q) return sessions
  return sessions.filter(
    (s) =>
      (s.user.name?.toLowerCase().includes(q) ?? false) ||
      s.user.email.toLowerCase().includes(q)
  )
}
